import React, {useState} from 'react';

export function kioskPhotoPath(value) {
  if (typeof value !== 'string') return '';
  // Use only local profile photos, without exposing other uploaded documents.
  const path=value.trim().replace(/^https:\/\/books\.bloanshandbags\.com(?=\/)/i,'');
  return /^\/uploads\/photos\/[a-z0-9_-][a-z0-9_.-]*\.(png|jpe?g|webp|gif)$/i.test(path) ? path : '';
}

export default function KioskStaffPhoto({person,compact=false}) {
  const source=kioskPhotoPath(person && person.photo_url);
  const [failedSource,setFailedSource]=useState(null);
  const showPhoto=source && failedSource!==source;
  const name=String(person && person.name || 'Staff member').trim();
  return <div style={{width:compact?56:76,height:compact?68:92,borderRadius:10,
    overflow:'hidden',flexShrink:0,margin:compact?0:'0 auto 10px',
    background:'#E8E1D3',border:'2px solid #A8893D',display:'flex',
    alignItems:'center',justifyContent:'center',boxSizing:'border-box'}}>
    {showPhoto ? <img src={source} alt={name+' passport photo'}
      onError={()=>setFailedSource(source)}
      style={{display:'block',width:'100%',height:'100%',objectFit:'cover',objectPosition:'center top'}} /> :
      <svg role="img" aria-label={'Photo unavailable for '+name} viewBox="0 0 64 80"
        width="100%" height="100%" focusable="false">
        <circle cx="32" cy="25" r="13" fill="#556B2F" />
        <path d="M8 75V63c0-16 10-23 24-23s24 7 24 23v12z" fill="#556B2F" />
      </svg>}
  </div>;
}
